import type { CartableProduct, Device, Match, Medication } from '@/hooks/escript/types';

export function isDevice(product: CartableProduct): product is Device {
  return (
    'id' in product &&
    'isRecommended' in product &&
    'supplier' in product &&
    !('token' in product) &&
    !('prescriptionCode' in product)
  );
}

export function isMedication(product: CartableProduct): product is Medication {
  return 'id' in product && 'prescriptionCode' in product && !('token' in product) && !('isRecommended' in product);
}

export function isMatch(product: CartableProduct): product is Match {
  return 'token' in product && 'name' in product && !('id' in product);
}
